var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGradientCheck = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check",
    transform: "translate(-9.182 -10.676)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1500",
    "data-name": "Path 1500",
    d: "M17.609,10.952a.914.914,0,0,1,1.3-.013.926.926,0,0,1,.013,1.3l-4.883,6.137a.914.914,0,0,1-1.321.025L9.48,15.151a.924.924,0,0,1,.4-1.574.915.915,0,0,1,.9.271l2.562,2.574,4.248-5.442a.289.289,0,0,1,.024-.027Z",
    transform: "translate(0 0)",
    fillRule: "evenodd",
    fill: "#265DF5"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGradientCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/gradient_check.e11c9f6816b2dbdfbf13ab1efe26ddaa.svg";